export default __webpack_public_path__ + "static/plinthes-0caef8cc78e4ce0cf5ee92938e86cd3b.jpg";